import { fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

export const USER_SOURCES_ROUTE_ID =
  "/_authenticated/orgs/$organizationId/projects/$projectId/user-sources" as const;

export const userSourcesSearchSchema = z.object({
  create: fallback(z.boolean(), false).default(false),
});

export type UserSourcesSearch = z.infer<typeof userSourcesSearchSchema>;

export const userSourcesSearchDefaults: UserSourcesSearch = {
  create: false,
};
